// eslint-disable-next-line no-extend-native
export default {
  'N/A': 'No disponible',
  tb: 'TB',
  gb: 'GB',
  mb: 'MB',
  kb: 'KB',
  b: 'B',
  'File extension error.': 'Error de extensi\u00f3n de archivo.',
  'File size error.': 'Error de tama\u00f1o de archivo.',
  'Duplicate file error.': 'Error, archivo duplicado',
  'Init error.': 'Error de inicializaci\u00f3n.',
  'HTTP Error.': 'Error de HTTP.',
  '%s specified, but cannot be found.': '%s especificado, pero no se puede encontrar',
  'You must specify either browse_button or drop_element.': 'Debe especificar el browse_button o el drop_element',
  'Select files': 'Elija archivos',
  'Add files to the upload queue and click the start button.': 'Agregue archivos a la lista de subida y pulse clic en el bot\u00f3n de Iniciar carga',
  List: 'Lista',
  Thumbnails: 'Miniaturas',
  Filename: 'Nombre de archivo',
  Status: 'Estado',
  Size: 'Tama\u00f1o',
  'Drag files here.': 'Arrastre archivos aqu\u00ed',
  'Add Files': 'Agregar archivos',
  'Start Upload': 'Iniciar carga',
  'Stop Upload': 'Detener Subida.',
  'File count error.': 'Error en contador de archivos.',
  'File: %s': 'Archivo: %s',
  'File: %s, size: %d, max file size: %d': 'Archivo: %s, tama\u00f1o: %d, tama\u00f1o m\u00e1ximo de archivo: %d',
  '%s already present in the queue.': '%s ya se encuentra en la lista.',
  'Upload element accepts only %d file(s) at a time. Extra files were stripped.': 'Se aceptan s\u00f3lo %d archivo(s) al tiempo. M\u00e1s, no se tienen en cuenta.',
  'Image format either wrong or not supported.': 'Formato de imagen no soportada.',
  'Runtime ran out of available memory.': 'No hay memoria disponible.',
  'Resoultion out of boundaries! <b>%s</b> runtime supports images only up to %wx%hpx.': 'Resoluci\u00f3n fuera de l\u00edmites! El tiempo de ejecuci\u00f3n <b>%s</b> s\u00f3lo admite im\u00e1genes hasta %wx%hpx',
  "Upload URL might be wrong or doesn't exist.": 'URL de carga inexistente.',
  Close: 'Cerrar',
  'Uploaded %d/%d files': 'Subidos %d/%d archivos',
  '%d files queued': '%d archivos en cola.',
  'Error: File too large:': 'Error: archivo demasiado grande:',
  'Error: Invalid file extension:': 'Error: Extensi\u00f3n de archivo inv\u00e1lida:'
}
